// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { editPromotion, getPromotionById } from "../../../features/promotion";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const EditPromotion = () => {
  const { id } = useParams<{ id: string }>();
  const { promotion, status } = useSelector((state: any) => state.promotion);
  const [language, setLanguage] = useState("en");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    sub_title: "",
    link: "",
    button_text: "",
    photo: null,
    is_home: false,
    is_special_for_you: false,
    start_date: "",
    end_date: "",
  });

  useEffect(() => {
    setFormData({
      title: "",
      sub_title: "",
      link: "",
      button_text: "",
      photo: null,
      is_home: false,
      is_special_for_you: false,
      start_date: "",
      end_date: "",
    });
    dispatch(getPromotionById({ id, lan: language }));
  }, [dispatch, id, language]);

  useEffect(() => {
    if (status && promotion) {
      const data = promotion.data;
      setFormData({
        title: data.title,
        sub_title: data.sub_title,
        link: data.link,
        button_text: data.button_text,
        is_home: data.is_home,
        is_special_for_you: data.is_special_for_you,
        start_date: data.start_date || "",
        end_date: data.end_date || "",
        photo: data.photo,
      });
    }
  }, [status, promotion]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        photo: e.target.files[0],
      }));
    }
  };

  const handleSubmit = () => {
    const formDataFinal = new FormData();

    formDataFinal.append("folder_name", "Promotion"); // Static folder_name
    formDataFinal.append("language", language);

    if (!formData.title.trim()) {
      toast.error("Title is required.");
      return;
    }
    if (!formData.sub_title.trim()) {
      toast.error("Sub Title is required.");
      return;
    }
    if (!formData.link.trim()) {
      toast.error("Link is required.");
      return;
    }
    if (!formData.button_text.trim()) {
      toast.error("Button Text is required.");
      return;
    }

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(
      editPromotion({ id, updatedPromotion: formDataFinal, lan: language })
    )
      .then((resultAction) => {
        if (editPromotion.rejected.match(resultAction)) {
          // This means it was a rejection, handle error
          // toast.error("An error occurred while creating the Promotion.");
          console.error(resultAction.payload || resultAction.error);
        } else {
          navigate("/promotion");
          toast.success("Promotion updated successfully!");
        }
      })
      .catch((err) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the Promotion.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />

      {/* Form Container */}
      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Edit Promotion
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Language Input */}
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px ",
                  fontWeight: "500",
                  lineHeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                <MenuItem style={{marginBottom:"5px" }} value="en">English</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>

          <Grid container spacing={2} sx={{ display: "flex", alignItems: "center"}}>
            <Grid item md={language === "en" ? 6 : 12} xs={12}>
              {/* Title Input */}
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Title
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="title"
                  placeholder="Enter the title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </SoftBox>
            </Grid>
            {language === "en" && (
              <>
                <Grid item md={6} xs={12}>
                  {/* Is Home Checkbox */}
                  <SoftBox
                    mb={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                    }}
                  >
                    <SoftBox sx={{ display: "flex", alignItems: "center" }}>
                      <input
                        name="is_home"
                        id="is_home"
                        type="checkbox"
                        checked={formData.is_home}
                        value={formData.is_home}
                        onChange={handleChange}
                        style={{
                          marginRight: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                        }}
                      />
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        htmlFor="is_home"
                      >
                        Is Home
                      </SoftTypography>
                    </SoftBox>
                    <SoftBox sx={{ display: "flex", alignItems: "center" }}>
                      <input
                        name="is_special_for_you"
                        id="is_special_for_you"
                        type="checkbox"
                        checked={formData.is_special_for_you}
                        value={formData.is_special_for_you}
                        onChange={handleChange}
                        style={{
                          marginRight: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                        }}
                      />
                      <SoftTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                        htmlFore="is_special_for_you"
                        
                      >
                        Is Special For You
                      </SoftTypography>
                    </SoftBox>
                  </SoftBox>
                </Grid>
              </>
            )}
          </Grid>
          {language === "en" && formData.is_special_for_you && (
            <Grid container spacing={2}>
              <Grid item md={6} xs={12}>
                <SoftBox mb={2}>
                  <SoftBox mb={1} ml={0.5}>
                    <SoftTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Start Date and Time
                    </SoftTypography>
                  </SoftBox>
                  <input
                    type="datetime-local"
                    name="start_date"
                    value={formData.start_date}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                    }}
                  />
                </SoftBox>
              </Grid>
              <Grid item md={6} xs={12}>
                <SoftBox mb={2}>
                  <SoftBox mb={1} ml={0.5}>
                    <SoftTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      End Date and Time
                    </SoftTypography>
                  </SoftBox>
                  <input
                    type="datetime-local"
                    name="end_date"
                    value={formData.end_date}
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      padding: "10px",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                    }}
                  />
                </SoftBox>
              </Grid>
            </Grid>
          )}

          {/* Sub Title Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Sub Title
              </SoftTypography>
            </SoftBox>
            <textarea
              name="sub_title"
              placeholder="Enter the sub title"
              value={formData.sub_title}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            />
          </SoftBox>

          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              {/* Button Text Input */}
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Button Text
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="button_text"
                  placeholder="Enter the Button Text"
                  value={formData.button_text}
                  onChange={handleChange}
                />
              </SoftBox>
            </Grid>
            <Grid item md={6} xs={12}>
              {/* Link Input */}
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Link
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="link"
                  placeholder="Enter the Link"
                  value={formData.link}
                  onChange={handleChange}
                />
              </SoftBox>
            </Grid>
          </Grid>

          {/* Photo Input */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Photo
              </SoftTypography>
            </SoftBox>
            {formData.photo && (
              <img
                src={
                  typeof formData.photo !== "string"
                    ? URL.createObjectURL(formData.photo)
                    : formData.photo
                }
                alt="Promotion"
                style={{ width: "150px", height: "150px", borderRadius: "5px" }}
              />
            )}
            <input
              type="file"
              name="photo"
              onChange={handlePhotoChange}
              style={{ width: "100%", padding:'10px', border:'1px solid #ccc', borderRadius:'5px' }}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditPromotion;
